define('home/views/ChannelCardCollectionViewWithChannelPromotion',[
    'home/views/ChannelCardCollectionView',

    'home/mixins/withInterstitialChannelCards',
], function (
    ChannelCardCollectionView,

    withInterstitialChannelCards
) {
    'use strict';

    /**
     * A feed of cards that inserts interstitial channel promotion cards.
     */
    var ChannelCardCollectionViewWithChannelPromotion = ChannelCardCollectionView.extend({});

    withInterstitialChannelCards.call(ChannelCardCollectionViewWithChannelPromotion.prototype);

    return ChannelCardCollectionViewWithChannelPromotion;
});

